export default "__VITE_PUBLIC_ASSET__7dbddce5__"